import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, tap } from 'rxjs';

@UntilDestroy()
@Injectable()
export class ServiceWorkerUpdateService {
  constructor(private swUpdate: SwUpdate) {}

  get isEnabled(): boolean {
    return this.swUpdate.isEnabled;
  }

  checkForUpdates(): void {
    this.swUpdate.versionUpdates
      .pipe(
        untilDestroyed(this),
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
        tap(() => {
          window.location.reload();
        })
      )
      .subscribe();
  }
}
